module.exports = require("request-promise-native");


//////////////////
// WEBPACK FOOTER
// external "request-promise-native"
// module id = 3
// module chunks = 0